import * as React from "react";
import mitt from "mitt";

export const emitterGVC = mitt();
export const emitterGVCContext = React.createContext(emitterGVC);

export function useGVCEmitter() {
  return React.useContext(emitterGVCContext);
}
